export enum EnumStatusCode {
  Success = 0,
  Fail = 1,
  LoginFail = 30001
}
